import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EmployeeModel } from 'projects/core/src/lib/models/employee.model';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';
import { EmployeeSearchComponent } from '../../../shared/employee-search/employee-search.component';

export interface ParticipantSetting {
  visible: boolean;
  required?: boolean;
}

export interface ParticipantData {
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
}

@Component({
  selector: 'app-participant-form',
  templateUrl: './participant-form.component.html',
  styleUrls: ['./participant-form.component.scss']
})
export class ParticipantFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() id: string;
  @Input() form: UntypedFormGroup;
  @Input() disabled = true;
  @Input() title: string | null;
  @Input() settings: ParticipantSetting;
  @Input() user: ParticipantData;
  @Input() wcSpecial = false;

  @ViewChild('employeesearch') employeesearch: EmployeeSearchComponent;

  public subForm: UntypedFormGroup = this.fb.group({
    firstname: new UntypedFormControl('', [Validators.required]),
    lastname: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, CustomValidators.email()]),
    mobile: new UntypedFormControl(''),
  });

  constructor(
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.form.addControl(this.id, this.subForm);
    if (this.disabled === true) {
      this.disable();
    }
    if (this.user) {
      this.subForm.patchValue(this.user);
    }
    // Initial validatoren setzen basierend auf settings
    if (this.settings) {
      this.setRequired(this.settings.required);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && changes.disabled.currentValue !== changes.disabled.previousValue) {
      if (changes.disabled.currentValue === true) {
        this.disable();
      } else {
        this.enable();
      }
    }
    if (changes.settings) {
      this.setRequired(changes.settings.currentValue.required);
    }
  }

  ngOnDestroy(): void {
    // Remove the subForm from the parent form when the component is destroyed
    if (this.form && this.id && this.form.contains(this.id)) {
      this.form.removeControl(this.id);
    }
  }

  public onOpenEmployeeSearch(): void {
    this.employeesearch.open();
  }

  public onSelectEmployee(employee: EmployeeModel): void {
    this.subForm.patchValue({
      firstname: employee.firstname,
      lastname: employee.lastname,
      email: employee.email,
      mobile: employee.mobile || employee.phone,
    });
  }

  public disable(): void {
    this.subForm.get('firstname').disable();
    this.subForm.get('lastname').disable();
    this.subForm.get('email').disable();
    this.subForm.get('mobile').disable();
  }

  public enable(): void {
    this.subForm.get('firstname').enable();
    this.subForm.get('lastname').enable();
    this.subForm.get('email').enable();
    this.subForm.get('mobile').enable();
  }

  public setRequired(required: boolean): void {
    if (required === true) {
      this.subForm.get('email').setValidators([Validators.required, CustomValidators.email()]);
    } else {
      this.subForm.get('email').setValidators([CustomValidators.email()]);
    }
    if (required === true && this.wcSpecial === false) {
      this.subForm.get('firstname').setValidators([Validators.required]);
      this.subForm.get('lastname').setValidators([Validators.required]);
    } else {
      this.subForm.get('firstname').clearValidators();
      this.subForm.get('lastname').clearValidators();
    }
    this.subForm.get('firstname').updateValueAndValidity();
    this.subForm.get('lastname').updateValueAndValidity();
    this.subForm.get('email').updateValueAndValidity();
  }

  public getPayload(): any | null {
    if (this.subForm.valid === true && this.subForm.get('email').value) {
      return {
        firstname: this.subForm.get('firstname').value,
        lastname: this.subForm.get('lastname').value,
        email: this.subForm.get('email').value,
        mobile: this.subForm.get('mobile').value,
      };
    } else {
      return null;
    }
  }


}
